import { render, staticRenderFns } from "./ed-calendar.vue?vue&type=template&id=1d4bb96b&scoped=true&"
import script from "./ed-calendar.ts?vue&type=script&lang=js&"
export * from "./ed-calendar.ts?vue&type=script&lang=js&"
import style0 from "./ed-calendar.scss?vue&type=style&index=0&id=1d4bb96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4bb96b",
  null
  
)

export default component.exports